import { observer } from "mobx-react";
import Image from "next/image";
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";
import SectionsRenderer from '@/components/sections/SectionsRenderer';
import DefaultPageContent from '@/components/page-templates/DefaultPageContent';
import SideMenu from '@/components/menus/SideMenu';
import { replaceBackendWithFrontendUrl } from '@/utils/misc';
const ContentPage = observer(({
  pageData,
  crossSellProducts,
  sideMenuData,
  featuredProductsList,
  sliderProductsList,
}) => {
  const mainImage = pageData.acf?.main_image;
  const hasSideMenu = pageData.acf?.enable_side_menu && sideMenuData?.items?.length > 0;
  const selectedPage = replaceBackendWithFrontendUrl(pageData.link);

  return (
    <>
      <Header title={pageData.title?.rendered} />
      <main className="products-background pt-[5rem] lg:pt-36 pb-18">
        {mainImage && (
          <div className="relative w-full h-[10rem] md:h-[12rem] lg:h-[18.75rem] overflow-hidden">
            <Image src={mainImage} alt={pageData.title?.rendered} style={{ objectFit: "cover" }} fill />
          </div>
        )}
        <div className="2xl:container mx-auto min-h-screen md:py-8 xl:py-10 2xl:py-12">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Side Menu - Now using the SideMenu component */}
            {hasSideMenu && (
                <SideMenu menuData={sideMenuData} selectedPage={selectedPage} />
            )}
            {/* Main Content - Adjust width calculation if needed based on SideMenu presence */}
            <div className={`w-full ${hasSideMenu ? 'md:w-[77%] lg:w-[83%]' : 'w-full'} mt-4 md:mt-0 px-4 2xl:px-0`}>
              {!pageData.acf?.sections || pageData.acf.sections.length === 0 ? (
                <DefaultPageContent pageData={pageData} />
              ) : (
                <SectionsRenderer sections={pageData.acf.sections} crossSellProducts={crossSellProducts} featuredProductsList={featuredProductsList} sliderProductsList={sliderProductsList} />
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
});

export default ContentPage;